<template>
  <footer class="app-footer" style="margin-left: 0;height: 250px;line-height: 18px;" :style="footerStyle">
    <div class="footer" style="height: 250px">
      <div style="" class="footer_content" id="footer_content">
        <div class="content_main fifteen_width">
          <div class="header_font"><span>产品</span></div>
          <div style="padding-top: 30px;">
            <div class="content_div"><a class="content_font">精准获客+CRM平台</a></div>
            <div class="content_div"><a class="content_font">企业数据中心</a></div>
            <div class="content_div"><a class="content_font">投融资数据平台</a></div>
            <div class="content_div"><a class="content_font">企业风控数据平台</a></div>
          </div>
        </div>
        <div class="content_main fifteen_width">
          <div class="header_font"><span>数据服务</span></div>
          <div style="padding-top: 30px;">
            <div class="content_div"><a class="content_font">客户精准推荐模型</a></div>
            <div class="content_div"><a class="content_font">企业创新能力评估模型</a></div>
            <div class="content_div"><a class="content_font">企业风控能力评估模型</a></div>
            <div class="content_div"><a class="content_font">大数据清洗服务</a></div>
          </div>
        </div>
        <div class="content_main fifteen_width">
          <div class="header_font"><span>招商加盟</span></div>
          <div style="padding-top: 30px;">
            <div class="content_div"><a class="content_font">加盟商通道</a></div>
            <div class="content_div"><a class="content_font">服务商查询</a></div>
          </div>
        </div>
        <div class="content_main fifteen_width">
          <div class="header_font"><span>关于我们</span></div>
          <div style="padding-top: 30px;">
            <div class="content_div"><a class="content_font">公司简介</a></div>
            <div class="content_div"><a class="content_font">合作伙伴</a></div>
            <div class="content_div"><a class="content_font">招贤纳士</a></div>
          </div>
        </div>
        <div class="content_main twenty_width">
          <div class="header_font"><span>联系方式</span></div>
          <div style="padding-top: 30px;">
            <div class="content_div"><a class="content_font">电话：010-82810650</a></div>
            <!--<div class="content_div"><a class="content_font">手机：18510772398</a></div>-->
            <div class="content_div"><a class="content_font">邮箱：market@dataadt.com</a></div>
            <!--   <div class="content_div"><a class="content_font">微信：18510772398</a></div>-->
            <div class="content_div"><a class="content_font">Q Q：514027267</a></div>
            <div class="content_div"><a class="content_font">Q 群：779652138</a></div>
          </div>
        </div>
        <div class="content_main twenty_width" style="height: 250px;">
          <div class="header_font"><span>企通查APP</span></div>
          <div style="padding-top: 30px;">
            <div style="width: 90px;height: 110px;float: left;">
              <div><img src="/static/img/home/Android.png"/></div>
              <div style="padding-left: 10px;"><span class="content_font">Android</span></div>
            </div>
            <div style="width: 90px;height: 110px;float: left;">
              <div><img src="/static/img/home/iOS.png"/></div>
              <div style="padding-left: 24px;"><span class="content_font">iOS</span></div>
            </div>
            <div style="width: 100px;height: 40px;float: left;padding-top: 5px;">
              <div style="width: 80px;height: 26px;border-radius: 4px;padding-top: 4px;padding-left: 10px;border: 1px solid #e3e3e3">
                <a class="content_font" id="online">在线咨询</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'footer',
  data() {
    return {
      footerStyle:{
        paddingLeft:window.innerWidth>1000?(window.innerWidth-990)*0.5+"px":"10px"
      },
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  methods:{
    handleResize() {
      this.footerStyle = {
        paddingLeft:window.innerWidth>1000?(window.innerWidth-990)*0.5+"px":"10px"
      }
    },
  }
}
</script>
<style>
  .footer_content{
    width: 980px;
  }
  .content_main{
    height:100%;
    float: left;
    padding-top: 30px
  }
  .fifteen_width{
    width: 15%;
  }
  .twenty_width{
    width: 20%;
  }
  .header_font{
    font-family: MicrosoftYaHei,sans-serif;
    font-size: 17px;
    color: #333333;
  }
  .content_div{
    height: 25px;
  }
  .content_font{
    font-family: "Microsoft YaHei", sans-serif;
    font-size: 13px;
    color: #666666;
  }
</style>



// WEBPACK FOOTER //
// Footer.vue?23b6569f